import { ActivitiesFormData } from "./Activities.type";
import { ActivityDataGrid } from "src/components/ActivityDataGrid/ActivityDataGrid";
import { EmptyRowsFallback } from "src/components/Grid/EmptyRowsFallback";
import { useTranslation } from "react-i18next";
import { useActivitiesColumns } from "./useActivitiesColumns";

export type SuppliersListProps = {
    activities: ActivitiesFormData;
    toggleEditMode: boolean;
    onActivitiesUpdate: (value: ActivitiesFormData) => void;
};

export const SuppliersList = (props: SuppliersListProps) => {
    const { t } = useTranslation();
    const { activities } = props;
    const columns = useActivitiesColumns(props.toggleEditMode, props.activities, props.onActivitiesUpdate);

    return (
        <ActivityDataGrid
            columns={columns}
            property="ingredientSupplierActivityDatas"
            data={activities.suppliers}
            enablePagination={false}
            renderEmptyRowsFallback={() => <EmptyRowsFallback message={t("il_n_y_a_aucun_thematique_a_afficher")} />}
        />
    );
};
